import BaseComponent from "../../../baseComponent.js";
import Dataset from "./dataset.jsx";

export default class DatasetList extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleScroll(e) {
    var target = e.target;
    if ($(target).scrollTop() + $(target).innerHeight() + 10 >= $(target)[0].scrollHeight) {
      this.props.getNextPage();
    }
  }

  render() {
    var datasets = [];
    for (var i = 0; i < this.props.datasets.length; i++) {
      datasets.push(<Dataset dataset={this.props.datasets[i]} key={i}/>);
    }
    var style = {
      opacity: this.props.datasets.length ? 1 : 0
    };

    return (
      <div className="studio-dataset-list" style={style}>
        <div className="pageable-list" onScroll={this.handleScroll}>
          <ul>
            {datasets}
          </ul>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/header/datasetList.jsx